module.exports = __webpack_public_path__ + "static/media/vu.b2c0b7f1.svg";